module.exports = __webpack_public_path__ + "img/user_order-empty.ee355912.png";